import { abilitiesPlugin } from "@casl/vue";
import { ability } from "@/abilities/ability";

export default {
  install(app) {
    app.use(abilitiesPlugin, ability, {
      useGlobalProperties: true,
    });
  },
};
